module.exports = __webpack_public_path__ + "img/messege_icon.18b6acce.svg";